import { cn } from "@/lib/utils";

type UserAvatarProps = {
  name: string;
  image?: string | null;
  className?: string;
};

const initialsFor = (name: string) =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || "U";

export const UserAvatar = ({ name, image, className }: UserAvatarProps) => (
  <span
    aria-label={name}
    className={cn(
      "inline-grid size-8 shrink-0 place-items-center overflow-hidden rounded-full bg-neutral-950 text-[0.6875rem] font-semibold text-white outline-1 -outline-offset-1 outline-black/10",
      className
    )}
    title={name}
  >
    {image ? <img alt="" className="size-full object-cover" src={image} /> : initialsFor(name)}
  </span>
);
